
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhyChooseUs from './components/WhyChooseUs';
import ServicesPreview from './components/ServicesPreview';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import Events from './components/Events';
import MapContact from './components/MapContact';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <WhyChooseUs />
        <ServicesPreview />
        <Gallery />
        <Testimonials />
        <Events />
        <MapContact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
